module.exports = __webpack_public_path__ + "icons/original/small/small-b6.0b3f448c498b70903671a4bc69efde0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-b6.png
// module id = Z31m
// module chunks = app